import { Component } from 'preact';
import { Text } from 'preact-i18n';
import Select from '../form/Select';
import get from 'get-value';

import { fanModesFor, fanModeLabelKey } from '../../utils/fanModes';
import withIntlAsProp from '../../utils/withIntlAsProp';

class SelectFanMode extends Component {
  handleValueChange = ({ value }) => {
    this.props.updateValue(value);
  };

  getOptions = () => {
    const { deviceFeature } = this.props;
    const deviceFeatureOptions = fanModesFor(deviceFeature).map(value => {
      return {
        label: get(this.props.intl.dictionary, fanModeLabelKey(deviceFeature, value), {
          default: value
        }),
        value
      };
    });

    this.setState({ deviceFeatureOptions });
  };

  getSelectedOption = () => {
    const value = this.props.value;

    if (value !== undefined) {
      return {
        label: get(this.props.intl.dictionary, fanModeLabelKey(this.props.deviceFeature, value), {
          default: value
        }),
        value
      };
    }
    return undefined;
  };

  componentDidMount() {
    this.getOptions();
  }

  render(props, { deviceFeatureOptions }) {
    const selectedOption = this.getSelectedOption();
    return (
      <Select
        class="select-device-feature"
        defaultValue=""
        value={selectedOption}
        onChange={this.handleValueChange}
        options={deviceFeatureOptions}
        placeholder={<Text id="global.selectPlaceholder" />}
        className="react-select-container"
        classNamePrefix="react-select"
      />
    );
  }
}

export default withIntlAsProp(SelectFanMode);
